import { API } from '../../core/http/api'

export function parseMessageFromAPI (item) {
  // eslint-disable-next-line
    let text = item.html ? undefined : (item.plain ||
  // eslint-disable-next-line
     ( item.plain === "\n" || item.plain !== null || item.plain?.length === 0 ) ? item.plain : "Only subject mail") 

  const html = item.html

  return {
    attachments: item.attachments || [],
    id: item.id,
    descendantsCount: item.descendants,
    messageid: item.messageid,
    subject: item.subject || '',
    text: text,
    fromEmail: item.emails && item.emails[0] || '!missing-email',
    emailsArray: item.emails,
    fromEmailRaw: item.emailsraw && item.emailsraw[0] || '!missing-email-raw',
    fromEmailOnlyName: item.emailsraw && item.emailsraw[0].replace(/ *<.*?>/, '') || '!missing-email-raw',
    date: item.createdAt, // .replace('T', ' ').replace('Z', ''),
    dateRaw: item.createdAt, // .replace('T', ' ').replace('Z', ''),
    updatedAt: item.updatedAt,
    visible: true,
    boxName: item.boxname,
    boxid: item.boxid,
    html,
    msgreferences: item.msgreferences,
    descendants: [],
    repliable: item.repliable,
    unopen: item.unopen,
    isspam: item.isspam,
    isvirusfree: item.isvirusfree === null || item.isvirusfree === true,
    headers: item.headers && transformHeadersArrayIntoObject(item.headers),
    deleted: item.deleted,
    pinned: item.pinned,
    tos: item.tos,
    senderFaviconUrl: transformFaviconUrlInCaseIsNeeded(item.senderfaviconurl, item.emails && item.emails[0]),
  }
}

function transformHeadersArrayIntoObject (headers) {
  const obj = {}
  headers.forEach((header) => {
    const matches = header.line.match(/(\w+|-)+:/)
    const value = header.line.replace(matches[0], '')
    obj[matches[0]] = value
  })
  return obj
}

export const markMessageAsRead = async (messageId) => {
  const res = await API.put(`messages/${messageId}`,
    {
      unopen: false
    }, {
      validateStatus: status => (status >= 200 && status < 300) || status === 404
    })
  if (res.status !== 200) API.controlStatusFnct(res, `Unexpected status code for PUT /messages/${messageId}`)
}

export const _getOriginalMessage = async (messageId) => {
  const res = await API.get(`messages/raw/${messageId}`, {
    validateStatus: status => (status >= 200 && status < 300) || status === 404
  })
  if (res.status !== 200) API.controlStatusFnct(res, `Unexpected status code for PUT /messages/${messageId}`)
  return res.data
}

const transformFaviconUrlInCaseIsNeeded = (senderFaviconUrl, fromEmail) => {
  if (senderFaviconUrl?.charAt(0) === '/') {
    const messageOriginDomain = fromEmail?.split('@')[1]
    return `https://${messageOriginDomain}${senderFaviconUrl}`
  }
  return senderFaviconUrl
}
